module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout"
  }, [_c('mu-appbar', {
    staticClass: "title",
    attrs: {
      "title": "项目介绍"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "left",
      "icon": "arrow_back"
    },
    on: {
      "click": _vm.goBack
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('mu-breadcrumb', [_c('mu-breadcrumb-item', {
    attrs: {
      "href": "/https://github.com/wangdabaoqq/VueCnode"
    }
  }, [_vm._v("VueCnode项目地址")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('mu-sub-header', [_vm._v("介绍如下:")]), _vm._v(" "), _c('mu-content-block', [_vm._v("\n        此项目本来打算是练练手,然后跟着项目学习学习vue,当然在项目当中遇到了很多问题,有解决的也有没有解决的,没有解决的后期我会继续\n        进行解决,如果你想了解更多的内容详情,独家新闻请点击左上方的地址进行查看。希望各位看官老爷,技术大牛等等爸爸们,可以给个start,稍微\n        鼓励下,你看怎么样。万分感谢！那我就先告辞。\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_vm._v("\n    VueCnode ©2017 Created github\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01f562d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 149
// module chunks = 2